import type { ReactNode } from 'react'

interface FolderGridProps {
  children: ReactNode
}

export function FolderGrid({ children }: FolderGridProps) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,320px),1fr))] gap-3">
      {children}
    </div>
  )
}

interface FolderGridSkeletonProps {
  label: string
  count?: number
}

export function FolderGridSkeleton({
  label,
  count = 4,
}: FolderGridSkeletonProps) {
  return (
    <div role="status" aria-label={label}>
      <FolderGrid>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="flex min-h-24 min-w-0 items-center gap-3 rounded-xl border border-border bg-card p-4 animate-pulse"
          >
            <div className="h-10 w-10 shrink-0 rounded-lg bg-muted" />
            <div className="flex min-w-0 flex-1 flex-col gap-2">
              <div className="h-4 w-3/4 rounded bg-muted" />
              <div className="h-3 w-1/3 rounded bg-muted" />
            </div>
          </div>
        ))}
      </FolderGrid>
    </div>
  )
}
